import { cssVar, theme } from '@zoomit/zoomit-ds';

export const scoreColor = (score: number) => {
  if (score >= 0 && score < 3) return cssVar(theme.error);
  if (score >= 3 && score < 4) return cssVar(theme.warning1);
  return cssVar(theme.success1);
};
